// import React, { useContext, useEffect, useState } from 'react';
// import { useSelector } from 'react-redux';
// import Swal from 'sweetalert2';
// import axios from 'axios';
// import { Context } from './Context';
// import '../CSS/MyCoursesPage.css';
// import { Link } from 'react-router-dom';

// const MyCoursesPage = () => {
//   const [myCourses, setMyCourses] = useState([]);
//   const { orderListGetUrl, courses } = useContext(Context);
//   const userInfo = useSelector(state => state.userInfo);

//   const fetchOrders = async () => {
//     const loadingAlert = Swal.fire({
//       text: "Fetching your courses",
//       allowOutsideClick: false,
//       allowEscapeKey: false,
//       showConfirmButton: false
//     });

//     Swal.showLoading();

//     try {
//       const userId = userInfo.id; // Ensure this is the correct value
//       if (!userId) {
//         throw new Error('User ID is missing');
//       }

//       const response = await axios.post(orderListGetUrl, { user_id: userId }, {
//         headers: {
//           'Content-Type': 'application/json'
//         }
//       });

//       console.log('Orders fetched:', response.data);
//       console.log(userInfo.id)
//       setMyCourses(response.data);
//     } catch (error) {
//       console.error('Error fetching orders:', error);
//       Swal.fire({
//         icon: "error",
//         title: "Fetch Orders Failed",
//         text: error.response?.data?.error || 'An error occurred.',
//         showConfirmButton: false,
//         timer: 3000
//       });
//     } finally {
//       loadingAlert.close();
//     }
//   };

//   useEffect(() => {
//     fetchOrders();
//   }, []); // Fetch orders on component mount



//   return (
//     <div className="my-courses-page">
//       <h2>MY COURSES</h2>
//       <ul>
//         {myCourses.map((order) => (
//           <div className='my-course' key={order.id}>
//             <p>Transaction: {order.transaction_reference}</p>
//             <ul>
//               {order.cart_items.map((cartItem) => {
//                 // const course = courses.find(c => c.id === cartItem.id);
//                 return (
//                   <li key={cartItem.id} className="OneCourse">
//                     {/* {course && <img src={`https://elexdondigitalacademy.com/api/uploads/${cartItem.image}`} alt="courseImg" />} */}
//                     <p>{cartItem.title}</p>
//                     <Link to={`/coursedetail/${cartItem.id}`}>
//                       <button>Take Course</button>
//                     </Link>
//                   </li>
//                 );
//               })}
//             </ul>
//           </div>
//         ))}
//       </ul>
//     </div>
//   );
// };

// export default MyCoursesPage;



// src/components/MyCoursesPage.jsx
import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import axios from 'axios';
import { Context } from './Context';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const MyCoursesPage = () => {
  const [myCourses, setMyCourses] = useState([]);
  const { orderListGetUrl } = useContext(Context);
  const userInfo = useSelector(state => state.userInfo);

  const fetchOrders = async () => {
    Swal.fire({
      text: "Fetching your courses...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const userId = userInfo?.id;
      if (!userId) {
        throw new Error('User ID is missing');
      }

      const response = await axios.post(orderListGetUrl, { user_id: userId }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      console.log('Orders fetched:', response.data);
      setMyCourses(response.data);
      Swal.close();
    } catch (error) {
      console.error('Error fetching orders:', error);
      Swal.fire({
        icon: "error",
        title: "Fetch Orders Failed",
        text: error.response?.data?.error || 'An error occurred.',
        showConfirmButton: false,
        timer: 3000
      });
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  return (
    <PageContainer>
      <PageHeader>
        <h2>My Enrolled Courses</h2>
        <p>Access your purchased courses and training modules below.</p>
      </PageHeader>

      {myCourses.length === 0 ? (
        <EmptyStateCard>
          <span style={{ fontSize: '2.5rem' }}>📚</span>
          <h3>No Courses Found</h3>
          <p>You have not purchased a course yet.</p>
        </EmptyStateCard>
      ) : (
        <OrdersList>
          {myCourses.map((order) => (
            <OrderCard key={order.id}>
              <OrderHeader>
                <span>Transaction Ref: <strong>{order.transaction_reference}</strong></span>
                <StatusBadge>Enrolled</StatusBadge>
              </OrderHeader>

              <CoursesGrid>
                {order.cart_items.map((cartItem) => (
                  <CourseCardItem key={cartItem.id}>
                    {cartItem.image && (
                      <CourseImage 
                        src={`https://elexdondigitalacademy.com/api/uploads/${cartItem.image}`} 
                        alt={cartItem.title} 
                      />
                    )}
                    <CourseDetails>
                      <CourseTitle>{cartItem.title}</CourseTitle>
                      <Link to={`/coursedetail/${cartItem.id}`} style={{ textDecoration: 'none' }}>
                        <ActionButton>Take Course</ActionButton>
                      </Link>
                    </CourseDetails>
                  </CourseCardItem>
                ))}
              </CoursesGrid>
            </OrderCard>
          ))}
        </OrdersList>
      )}
    </PageContainer>
  );
};

export default MyCoursesPage;

// --- Styled Components ---
const PageContainer = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  font-family: inherit;
`;

const PageHeader = styled.div`
  margin-bottom: 24px;

  h2 {
    color: #0f172a;
    font-size: 1.8rem;
    font-weight: 700;
    margin: 0 0 4px 0;
  }

  p {
    color: #64748b;
    font-size: 0.95rem;
    margin: 0;
  }
`;

const EmptyStateCard = styled.div`
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  padding: 48px 24px;
  text-align: center;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);

  h3 {
    color: #0f172a;
    margin: 12px 0 6px 0;
    font-size: 1.2rem;
  }

  p {
    color: #64748b;
    font-size: 0.95rem;
    max-width: 400px;
    margin: 0 auto;
  }
`;

const OrdersList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const OrderCard = styled.div`
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
  padding: 20px 24px;
`;

const OrderHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 14px;
  border-bottom: 1px solid #f1f5f9;
  margin-bottom: 16px;
  font-size: 0.9rem;
  color: #64748b;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

const StatusBadge = styled.span`
  background: #dcfce7;
  color: #166534;
  padding: 2px 10px;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
`;

const CoursesGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const CourseCardItem = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #f1f5f9;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const CourseImage = styled.img`
  width: 80px;
  height: 60px;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
`;

const CourseDetails = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`;

const CourseTitle = styled.h4`
  color: #1e293b;
  font-size: 1.05rem;
  font-weight: 600;
  margin: 0;
`;

const ActionButton = styled.button`
  padding: 8px 16px;
  background-color: #2563eb;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.85rem;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #1d4ed8;
  }
`;